import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import Link from './Link';
import { linkType } from '../propTypes';
import theme from '../styles/theme';
import supportsInvertFilter from '../helpers/supportsInvertFilter';
import round from '../helpers/round';

const CtaButton = ({
  className,
  classes,
  defaultText,
  link,
  onMouseEnter,
  onMouseLeave,
  onClick,
  ComponentType,
  ...rest
}) => (
  <ComponentType
    className={cn(className, classes.cta)}
    defaultText={defaultText}
    link={link}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    onClick={onClick}
    {...rest}
  >
    <span className={classes.content}>
      <span className={classes.text}>
        {(link && link.text) || defaultText}
      </span>
    </span>
  </ComponentType>
);

CtaButton.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  defaultText: PropTypes.string,
  link: linkType,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func,
  ComponentType: PropTypes.oneOfType([
    PropTypes.instanceOf(React.Component),
    PropTypes.func,
  ]),
};

CtaButton.defaultProps = {
  className: undefined,
  defaultText: undefined,
  onMouseEnter: undefined,
  onMouseLeave: undefined,
  onClick: undefined,
  ComponentType: Link,
  link: undefined,
};

const fontSizes = {
  sm: 11,
  [theme.breakpoints.wideMobile]: 12,
  md: 16,
};
const letterSpacing = 2.29;
const em = (px, bp = 'md') => `${round(px / fontSizes[bp])}em`;
export default injectSheet({
  cta: {
    display: 'inline-block',
    verticalAlign: 'middle',
    lineHeight: 1,
    border: '1px solid',
    borderRadius: 2,
    transition: 'background-color 0.2s ease-out',
    '&, .cms-content &[href]': {
      textDecoration: 'none',
      lineHeight: '24px',
    },
    '&, &:visited, &:focus, &:hover': {
      color: 'inherit',
    },
    ...(supportsInvertFilter && {
      '&:hover, &:focus': {
        backgroundColor: 'currentColor',
        '& $text': {
          filter: 'invert(100%)',
        },
      },
    }),
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: theme.fonts.bold,
    fontWeight: theme.fonts.boldWeight,
    fontSize: fontSizes.sm,
    textTransform: 'uppercase',
    letterSpacing: `${letterSpacing}px`,
    paddingLeft: em(2 * theme.padding.gutter),
    paddingRight: em(2 * theme.padding.gutter),
    height: em(54),
    [theme.breakpoints.up(theme.breakpoints.wideMobile)]: {
      fontSize: fontSizes[theme.breakpoints.wideMobile],
    },
    [theme.breakpoints.up('md')]: {
      fontSize: fontSizes.md,
    },
  },
  text: {
    display: 'block',
    fontSize: 16,
    whiteSpace: 'nowrap',
  },
})(CtaButton);
